/**
* [Flags]
*/
export var AssignmentFolderRights;
(function (AssignmentFolderRights) {
    AssignmentFolderRights[AssignmentFolderRights["None"] = 0] = "None";
    AssignmentFolderRights[AssignmentFolderRights["Use"] = 1] = "Use";
    AssignmentFolderRights[AssignmentFolderRights["Open"] = 2] = "Open";
    AssignmentFolderRights[AssignmentFolderRights["View"] = 4] = "View";
    AssignmentFolderRights[AssignmentFolderRights["Edit"] = 8] = "Edit";
    AssignmentFolderRights[AssignmentFolderRights["Add"] = 16] = "Add";
    AssignmentFolderRights[AssignmentFolderRights["Delete"] = 32] = "Delete";
    AssignmentFolderRights[AssignmentFolderRights["Administrate"] = 64] = "Administrate";
    AssignmentFolderRights[AssignmentFolderRights["All"] = 127] = "All";
})(AssignmentFolderRights || (AssignmentFolderRights = {}));
;
